// extracted by mini-css-extract-plugin
export default {"container":"Widget--container--055171"};